import { fileUrl } from "../utils/utils";

const adapterFileFromApi = (file_from_api) => {
    const { fileId, tags } = file_from_api;

    //Creo un objeto, cuyas propiedades son los tags que posee el file

    let adaptedFile = {
        fileId,
    };

    tags.forEach((tag) => {
        const { key, value } = tag;
        adaptedFile[key] = value;
    });

    return formatFile(adaptedFile);
};

const formatFile = (file) => {
    const { fileId, ORIGINAL_FILENAME, SUBCONTEXTO: subcontexto, URL } = file;
    return {
        uid: fileId,
        name: ORIGINAL_FILENAME,
        status: "done",
        subcontexto,
        // response: "Server Error 500", // custom error message to show
        url: fileUrl(URL),
    };
};

export { adapterFileFromApi };
